import React, { useState, useEffect } from "react";
import "./style.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MentorIcon from "../../../../../assets/svg/dashboard/Mentor-iconCircle.svg";
import StartupIcon from "../../../../../assets/svg/dashboard/StartupIcon-Circle.svg";
import MentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { useHistory } from "react-router-dom";
import CohortIcon from "../../../../../assets/svg/dashboard/Cohort-Details.svg";
import {
  getActivitySummaryDashboard,
  getActivitySummaryMentorshipCount,
  getActivitySummaryStartupCount,
  getActivitySummaryCohortCount,
} from "../AdminMentorAction/dependencies/action";
const ActivitySummary = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const [isShown, setIsShown] = useState(false);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const history = useHistory();
  const {
    getActivitySummaryDashboard,
    getActivitySummaryData,
    getActivitySummaryMentorshipCount,
    getMentorshipCountData,
    getStartupCountData,
    getActivitySummaryStartupCount,
    getCohortCountData,
    getActivitySummaryCohortCount,
    getStepperTooltipData,
    getStepperData,
  } = props;
  useEffect(() => {
    html.style.overflow = "auto";

    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
    }, 1000);
    let params = {};
    getActivitySummaryDashboard(params);
    getActivitySummaryStartupCount(params);
    getActivitySummaryCohortCount(params);
    getActivitySummaryMentorshipCount();
  }, []);
  return (
    <div className="admindashboard-activitysummary">
      <div className="iconWith-heading" style={{ marginBottom: "-10px" }}>
        <div style={{ width: "100%" }}>
          <h3
            className="sub-heading fadeInDown wow"
            style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
          >
            MAARG Portal by Startup India
          </h3>
          <h3 className="dashboard-sub-heading fadeInDown wow mb-5">
            ADMIN DASHBOARD: ACTIVITY SUMMARY
          </h3>
        </div>
        <div
          className="tooltipshow eyeIcon"
          // onClick={() => {
          //   // html.style.overflow = "hidden";

          //   if (html.style.overflow == "auto") {
          //     html.style.overflow = "hidden";
          //   } else {
          //     html.style.overflow = "auto";
          //   }
          // }}
          style={{ marginRight: "35px" }}
        >
          <div className="newuserTooltip ">
            <img
              className="iconbtn top-btn"
              src={iconTooltip}
              onClick={() => {
                setModalIsOpenToTrue();
                if (html.style.overflow == "auto") {
                  html.style.overflow = "hidden";
                } else {
                  html.style.overflow = "auto";
                }
              }}
              width={60}
            />{" "}
            <span
              className="tooltiptext tooltip-bottom "
              style={{ width: "130px", top: "50px", left: "20px" }}
            >
              View Instructions
            </span>
          </div>
        </div>
        {isShown && (
          <div>
            <AnimeList
              setModalIsOpenToTrue={setModalIsOpenToTrue}
              Heading={Heading}
              InstructionswithRole={InstructionswithRole}
              SelectPage={SelectPage}
            />
          </div>
        )}
      </div>
      <div className="activitysummary">
        <div className="mentorship-btn purplebutton d-flex justify-content-center ">
          <p className="d-flex justify-content-center button-text04">Mentors</p>
          <div className="activity-svgIcon newuserTooltip">
            <img
              className="iconsvsg"
              src={MentorIcon}
              onClick={() => {
                history.push({
                  state: {
                    fromModule: "activitySummary",
                  },
                });
                localStorage.setItem("allMentorList", "allMentorList");
                window.location.reload();
              }}
            />
            <span
              className="tooltiptext tooltip-bottom tab-data"
              style={{
                left: "-2px",
                top: "59px",
                width: "200px",
              }}
            >
              Click to View All Mentors List
            </span>
          </div>
        </div>
        <div className="onerow row mb-4 mt-2">
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 ">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getActivitySummaryData &&
                  getActivitySummaryData?.respondedToAll}
              </p>
              <div className="textdata">Responded to All Requests</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  localStorage.setItem("activitySummary3", "activitySummary3");
                  // document.body.style.overflow = "hidden"
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Responded to All Requests
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 second-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getActivitySummaryData && getActivitySummaryData?.noRequests}
              </p>
              <div className="textdata">No Startup Requests Received</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  localStorage.setItem("activitySummary4", "activitySummary4");
                  // document.body.style.overflow = "hidden"
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View No Startup Requests Received
                </span>
              </div>
            </div>
          </div>

          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12  col-12 third-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getActivitySummaryData && getActivitySummaryData?.notLoggedIn}
              </p>
              <div className="textdata">Not Logged In Since Last 15 days</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2 "
                style={{ cursor: "pointer" }}
                onClick={() => {
                  localStorage.setItem("activitySummary5", "activitySummary5");
                  // document.body.style.overflow = "hidden"
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "48px",
                  }}
                >
                  View Not Logged In Since Last 15 days
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 fourth-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getActivitySummaryData &&
                  getActivitySummaryData?.respondedToFewOrNone}
              </p>
              <div className="textdata">
                Multiple Requests Received but Responded to None/Few in 15 Days
              </div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                    },
                  });
                  localStorage.setItem("activitySummary2", "activitySummary2");
                  window.location.reload();
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-74px",
                    width: "192px",
                    height: "67px",
                  }}
                >
                  View Multiple Requests Received but Responded to None/Few in
                  15 Days
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mentorship-btn purplebutton d-flex justify-content-center">
          <p className="button-text04">Startups</p>
          <div className="activity-svgIcon newuserTooltip">
            <img
              className="iconsvsg"
              src={StartupIcon}
              onClick={() => {
                history.push({
                  state: {
                    fromModule: "activitySummary",
                  },
                });
                localStorage.setItem("allStartupList", "allStartupList");
                window.location.reload();
              }}
            />
            <span
              className="tooltiptext tooltip-bottom tab-data"
              style={{
                left: "-2px",
                top: "59px",
                width: "200px",
              }}
            >
              Click to View All Startups List
            </span>
          </div>
        </div>
        <div className="onerow row mb-4 mt-2">
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="card-body flex-column d-flex">
              <p className="textnum">
                {getStartupCountData && getStartupCountData?.pending}
              </p>
              <div className="textdata">Number of Startup Request Sent</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2 "
                onClick={() => {
                  localStorage.setItem(
                    "startupRequestSent",
                    "startupRequestSent"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "requestSent",
                      pageCounter: getStartupCountData?.pending,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-5px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Number of Startup Request Sent
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 second-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getStartupCountData && getStartupCountData?.accepted}
              </p>
              <div className="textdata">Number of Startup Request Accepted</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2 "
                onClick={() => {
                  localStorage.setItem(
                    "startupRequestSent",
                    "startupRequestSent"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "requestAccepted",
                      pageCounter: getStartupCountData?.accepted,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "48px",
                  }}
                >
                  View Number of Startup Request Accepted
                </span>
              </div>
            </div>
          </div>

          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 third-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum">
                {getStartupCountData && getStartupCountData?.active}
              </p>
              <div className="textdata">Number of Mentorships Ongoing</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                onClick={() => {
                  localStorage.setItem(
                    "startupMentorshipHours",
                    "startupMentorshipHours"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "mentorshipOngoing",
                      pageCounter: getStartupCountData?.active,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Number of Mentorships Ongoing
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 fourth-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getStartupCountData &&
                  parseFloat(getStartupCountData?.completedHours).toFixed(2)}
              </p>
              <div className="textdata">
                Number of Hours of Mentorships Received
              </div>
              <div
                className="mentor-btn mt-auto mb-2 top-btn newuserTooltip"
                onClick={() => {
                  localStorage.setItem(
                    "startupMentorshipHours",
                    "startupMentorshipHours"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "mentorshipReceived",
                      pageCounter: parseFloat(
                        getStartupCountData?.completedHours
                      ).toFixed(2),
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Number of Hours of Mentorships Received
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mentorship-btn purplebutton d-flex justify-content-center">
          <p className="button-text04">Mentorships</p>
          <div className="activity-svgIcon newuserTooltip">
            <img
              className="iconsvsg"
              src={MentorshipIcon}
              onClick={() => {
                history.push({
                  state: {
                    fromModule: "activitySummary",
                  },
                });
                localStorage.setItem(
                  "startupMentorAllMentorships",
                  "startupMentorAllMentorships"
                );
                window.location.reload();
              }}
            />
            <span
              className="tooltiptext tooltip-bottom tab-data"
              style={{
                left: "-2px",
                top: "59px",
                width: "200px",
              }}
            >
              Click to View Mentorships
            </span>
          </div>
        </div>
        <div className="onerow row mb-4 mt-2">
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="card-body flex-column d-flex">
              <p className="textnum">{getMentorshipCountData?.totalRequests}</p>
              <div className="textdata"> Total Mentorship Requests Raised</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                onClick={() => {
                  localStorage.setItem("mentorshipTotal", "mentorshipTotal");
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageCounter: getMentorshipCountData?.totalRequests,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Total Mentorship Requests Raisedss
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 second-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getMentorshipCountData?.activeMentorships}
              </p>
              <div className="textdata"> Active Mentorship Sessions</div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2 "
                onClick={() => {
                  localStorage.setItem(
                    "mentorshipSession",
                    "mentorshipSession"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageCounter: getMentorshipCountData?.activeMentorships,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "7px",
                    top: "-52px",
                    width: "159px",
                    height: "46px",
                  }}
                >
                  View Active Mentorship Sessions
                </span>
              </div>
            </div>
          </div>

          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 third-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum">
                {getMentorshipCountData?.noSessionMentorships}
              </p>
              <div className="textdata">
                Mentorships with no sessions scheduled
              </div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                onClick={() => {
                  localStorage.setItem("mentorshipClosed", "mentorshipClosed");
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "mentorshipScheduled",
                      pageCounter: getMentorshipCountData?.noSessionMentorships,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-17px",
                    top: "-56px",
                    width: "207px",
                    height: "50px",
                  }}
                >
                  View Mentorships With No Sessions Scheduled
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 fourth-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getMentorshipCountData?.autoClosedMentorships}
              </p>
              <div className="textdata">Mentorships auto closed </div>
              <div
                className="mentor-btn mt-auto mb-2 top-btn newuserTooltip"
                onClick={() => {
                  localStorage.setItem("mentorshipClosed", "mentorshipClosed");
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activitySummary",
                      pageSection: "mentorshipClosed",
                      pageCounter:
                        getMentorshipCountData?.autoClosedMentorships,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-52px",
                    width: "183px",
                    height: "46px",
                  }}
                >
                  View Mentorships Auto Closed
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mentorship-btn purplebutton d-flex justify-content-center">
          <p className="button-text04">Cohorts</p>
          <div
            className="activity-svgIcon newuserTooltip"
            // style={{ position: "absolute", right: "18%" }}
          >
            <img
              className="iconsvsg"
              src={CohortIcon}
              onClick={() => {
                history.push({
                  state: {
                    fromModule: "activitySummary",
                  },
                });
                localStorage.setItem("cohortProgram", "cohortProgram");
                window.location.reload();
              }}
            />
            <span
              className="tooltiptext tooltip-bottom tab-data"
              style={{
                left: "-2px",
                top: "59px",
                width: "200px",
              }}
            >
              Click to View All Cohorts
            </span>
          </div>
        </div>{" "}
        <div className="onerow row mb-4 mt-2">
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="card-body flex-column d-flex">
              <p className="textnum">
                {getCohortCountData && getCohortCountData?.totalCohorts}
              </p>
              <div className="textdata">Total Cohorts Created </div>
              <div
                className="mentor-btn mt-auto newuserTooltip top-btn mb-2"
                onClick={() => {
                  localStorage.setItem(
                    "activityCohortTotal",
                    "activityCohortTotal"
                  );
                  // document.body.style.overflow = "hidden"
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activityCohortTotal",
                      pageCounter: getCohortCountData?.totalCohorts,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "7px",
                    top: "-52px",
                    width: "159px",
                    height: "46px",
                  }}
                >
                  View Total Cohorts Created
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 second-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getCohortCountData && getCohortCountData?.totalStartups}
              </p>
              <div className="textdata">Total Startups in the Cohorts </div>
              <div
                className="mentor-btn mt-auto top-btn mb-2 newuserTooltip"
                onClick={() => {
                  localStorage.setItem(
                    "activityCohortDetails",
                    "activityCohortDetails"
                  );
                  // document.body.style.overflow = "hidden"
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activityCohortDetailsStartup",
                      pageCounter: getCohortCountData?.totalStartups,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "7px",
                    top: "-52px",
                    width: "159px",
                    height: "46px",
                  }}
                >
                  View Total Startups In The Cohorts
                </span>
              </div>
            </div>
          </div>

          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 third-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum">
                {getCohortCountData && getCohortCountData?.totalMentors}
              </p>
              <div className="textdata">Total mentors in the cohorts </div>
              <div
                className="mentor-btn mt-auto mb-2 top-btn newuserTooltip"
                onClick={() => {
                  localStorage.setItem(
                    "activityCohortDetails",
                    "activityCohortDetails"
                  );
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activityCohortDetailsMentor",
                      pageCounter: getCohortCountData?.totalMentors,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "7px",
                    top: "-52px",
                    width: "159px",
                    height: "46px",
                  }}
                >
                  View Total Mentors In The Cohorts
                </span>
              </div>
            </div>
          </div>
          <div className="dashboard-card-activity shadow2 col col-lg-3 col-md-6 col-sm-12 col-12 fourth-Icon">
            <div className="card-body flex-column d-flex">
              <p className="textnum mb-2">
                {getCohortCountData && getCohortCountData?.hoursCompleted}
              </p>
              <div className="textdata">
                Total Mentorship Hours from the cohort-based program
              </div>
              <div
                className="mentor-btn mt-auto mb-2 top-btn newuserTooltip"
                onClick={() => {
                  localStorage.setItem("cohortProgram", "cohortProgram");
                  window.location.reload();
                  history.push({
                    state: {
                      fromModule: "activityCohortMentorships",
                      pageCounter: getCohortCountData?.hoursCompleted,
                    },
                  });
                }}
              >
                <p>VIEW DETAILS</p>
                <span
                  className="tooltiptext  close-summary"
                  style={{
                    left: "-8px",
                    top: "-74px",
                    width: "192px",
                    height: "67px",
                  }}
                >
                  View Total Mentorship Hours from The Cohort-Based Program
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getActivitySummaryData:
      state.AdminMentorReducer.getActivitySummaryDashboard.data,
    getMentorshipCountData:
      state.AdminMentorReducer.getActivitySummaryMentorshipCount.data,
    getStartupCountData:
      state.AdminMentorReducer.getActivitySummaryStartupCount.data,
    getCohortCountData:
      state.AdminMentorReducer.getActivitySummaryCohortCount.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getActivitySummaryDashboard,
  getActivitySummaryMentorshipCount,
  getActivitySummaryCohortCount,
  getActivitySummaryStartupCount,
  getStepperTooltipData,
})(withRouter(ActivitySummary));
